import { AnyAction } from '@reduxjs/toolkit';
import { ITaxonomy } from '../models/interfaces/ITaxonomy';

export const avatarOptions = [
	'assets/AvatarsPng/Avatar_2@3x.png',
	'assets/AvatarsPng/Avatar_3@3x.png',
	'assets/AvatarsPng/Avatar_4@3x.png',
	'assets/AvatarsPng/Avatar_5@3x.png',
	'assets/AvatarsPng/Avatar_6@3x.png',
	'assets/AvatarsPng/Avatar_7@3x.png',
];

// Usual actions are CRUD
export const UPDATE_PREFS_NAME = 'prefs/update/name';
export const UPDATE_PREFS_AVATAR = 'prefs/update/avatar';
export const UPDATE_PREFS_MIN_DIFFICULTY = 'prefs/update/min_difficulty';
export const UPDATE_PREFS_MAX_DIFFICULTY = 'prefs/update/max_difficulty';
export const UPDATE_PREFS_ACTIVITIES = 'prefs/update/activities';
export const UPDATE_PREFS_TOPICS = 'prefs/update/topics';
export const UPDATE_PREFS_ACCESSIBILITY = 'prefs/update/accessibility';
export const UPDATE_PREFS_UNITS = 'prefs/update/units';
export const UPDATE_PREFS_UNITS_TEMP = 'prefs/update/units_temp';
export const RESET_PREFS = 'prefs/reset';

export type PrefsPayload = {
	name?: string;
	avatar?: string;
	min_difficulty?: number;
	max_difficulty?: number;
	activities?: ITaxonomy[];
	topics?: ITaxonomy[];
	accessible?: boolean;
	preferred_dist_units?: string;
	preferred_temp_units?: string;
};

export type PrefsReducerAction = {
	type: string;
	payload: PrefsPayload;
};

export const prefsInitialState: PrefsPayload = {
	name: 'Explorer',
	avatar: avatarOptions[Math.floor(Math.random() * avatarOptions.length)],
	min_difficulty: 2,
	max_difficulty: 4,
	activities: [],
	topics: [],
	accessible: false,
	preferred_dist_units: 'km',
	preferred_temp_units: 'c',
};

export default function prefsReducer(
	state = prefsInitialState,
	action: AnyAction,
) {
	let new_state = Object.assign({}, state) as PrefsPayload;

	switch (action.type) {
		case UPDATE_PREFS_NAME: {
			new_state.name = action.payload.name;
			return new_state;
		}
		case UPDATE_PREFS_AVATAR: {
			new_state.avatar = action.payload.avatar;
			return new_state;
		}
		case UPDATE_PREFS_MIN_DIFFICULTY: {
			new_state.min_difficulty = action.payload.min_difficulty;
			return new_state;
		}
		case UPDATE_PREFS_MAX_DIFFICULTY: {
			new_state.max_difficulty = action.payload.max_difficulty;
			return new_state;
		}
			case UPDATE_PREFS_ACTIVITIES: {
				console.log('Update Activities :', action.payload.activities);
				new_state.activities = action.payload.activities
					? [...action.payload.activities]
					: [];
				return new_state;
			}
			case UPDATE_PREFS_TOPICS: {
				console.log('Update Topics :', action.payload.topics);
				new_state.topics = action.payload.topics
					? [...action.payload.topics]
					: [];
			return new_state;
		}
		case UPDATE_PREFS_ACCESSIBILITY: {
			console.log(
				'Update Accessibility Settings:',
				action.payload.accessible,
			);
			new_state.accessible = action.payload.accessible;
			return new_state;
		}

		case UPDATE_PREFS_UNITS: {
			console.log(
				'Update Units Settings:',
				action.payload.preferred_dist_units,
			);
			new_state.preferred_dist_units =
				action.payload.preferred_dist_units;
			return new_state;
		}

		case UPDATE_PREFS_UNITS_TEMP: {
			console.log(
				'Update Units Settings:',
				action.payload.preferred_temp_units,
			);
			new_state.preferred_temp_units =
				action.payload.preferred_temp_units;
			return new_state;
		}

		case RESET_PREFS: {
			return prefsInitialState;
		}
		default:
			return state;
	}
}
